import moment from 'moment';

export const formatDate = (date: string | Date | null | undefined): string => {
    return date ? moment(date).format('DD/MM/YYYY') : '';
};

export const formatTime = (time: string | null | undefined): string => {
    return time ? moment(time, 'HH:mm').format('HH:mm') : '';
};

export const formatDateTime = (date: string | Date | null | undefined, time?: string | null): string => {
    if (!date) return '';
    const formattedDate = moment(date).format('DD/MM/YYYY');
    if (!time) return formattedDate;
    return `${formattedDate} ${moment(time, 'HH:mm').format('HH:mm')}`;
}; 